import { render } from "./Fund.vue?vue&type=template&id=5d712adb&scoped=true"
import script from "./Fund.vue?vue&type=script&lang=js"
export * from "./Fund.vue?vue&type=script&lang=js"

import "./Fund.vue?vue&type=style&index=0&id=5d712adb&scoped=true&lang=css"

import exportComponent from "C:\\git\\fund\\vfund\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d712adb"]])

export default __exports__